import './styles.scss'
import PropTypes from 'prop-types'

const Box = (props) => {
    return (
      <div className="box" style={props.style}>
        <div className="boxInner">{props.children}</div>
      </div>
    )
}

Box.propTypes = {
  style: PropTypes.object,
  children: PropTypes.node,
}
export default Box
